import PropTypes from "prop-types";

export default PropTypes.shape({
  accountManager: PropTypes.bool.isRequired,
  authenticityToken: PropTypes.string.isRequired,
  badge: PropTypes.string,
  billingPeriod: PropTypes.string.isRequired,
  buttonName: PropTypes.string.isRequired,
  credits: PropTypes.number,
  currency: PropTypes.string.isRequired,
  customFields: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  oldPrice: PropTypes.number,
  paymentTerms: PropTypes.string,
  planClass: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  publishableKey: PropTypes.string.isRequired,
  sectors: PropTypes.number,
  serviceFee: PropTypes.string.isRequired,
  taxPercent: PropTypes.number.isRequired,
  userLimit: PropTypes.number.isRequired,
});
